import { clone } from "./clone"
import stickimposterFragmentShader from "./stickimposterFragmentShader.partial.frag"

export * from "./clone"
export const ShaderUtils = {
    clone,
    stickimposterFragmentShader
}